<template>
  <div class="pag">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title">SMS</h1>
        </div>
        <!--  <h3 style="color: #888888" class="subtitle">{{ getClientName() }}</h3> -->
      </div>
    </div>

    <section id="subPag">
      <div id="containerMessage">
        <b-field label="Mensagem" id="message">
          <b-input
            type="textarea"
            v-model="sms.message"
            :maxlength="maxLength"
            :has-counter="false"
          ></b-input>
        </b-field>
        <p
          :class="{
            sizeInputMedium: smsLength >= 120,
            sizeInputHigh: smsLength > 159
          }"
        >
          {{ smsLength }}/160
        </p>

        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <b-button
                type="is-info"
                icon-left="save"
                id="botton"
                @click="onSubmitFormSms()"
              >
                Salvar
              </b-button>
            </div>
            <div class="level-item">
              <div class="column is-2 is-full-mobile">
                <b-switch v-model="sms.isEnabled" class="toggle">
                  Envio Ativo
                </b-switch>
              </div>
            </div>
          </div>

          <div class="level-right">
            <div class="level-item">
              <b-button
                type="is-primary"
                icon-left="users"
                @click="openModal = !openModal"
              >
                Clientes Alcançados
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div id="textExplication">
        <p v-html="textSms"></p>
      </div>

      <b-modal :active.sync="openModal" :can-cancel="true">
        <table-sms :smsID="smsID"></table-sms>
      </b-modal>
    </section>
  </div>
</template>

<script>
import Webservices from "@/Webservices";
import store from "@/store";
import { mapGetters, mapActions } from "vuex";
import tableSms from "@/components/custom/tableSms";

var moment = require("moment");

const ws = new Webservices();
export default {
  components: {
    tableSms
  },
  data() {
    return {
      //campaignID: 0 por que não temos tabela de campaign ainda
      //nome do sms mocado por que nao temos mais de um
      sms: {
        campaignID: 0,
        clientID: "",
        name: "bem-vindo",
        message: "",
        isEnabled: false,
        category: "transactional",
        counter: 0
      },
      smsID: 0,
      clientName: "",
      labelPosition: "on-border",
      openModal: false,
      editSms: false,
      smsLength: 0,
      maxLength: 160
    };
  },
  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    this.getClientSms();
  },
  methods: {
    ...mapActions(["logout"]),
    onSubmitFormSms() {
      if (this.editSms) {
        ws.putSms(this.smsID, this.sms)
          .then(response => {
            //sucesso na edição do sms
          })
          .catch(() => {
            // falha na edição do sms
          });
      } else {
        this.sms.clientID = this.getID;
        ws.postSms(this.sms)
          .then(({ data }) => {
            //fazer algo quando cadastrar o sms
          })
          .catch(() => {
            //fazer algo na falha do cadastro de sms
          });
      }
    },
    getClientSms() {
      ws.getSms(this.getID)
        .then(response => {
          const sms = response.data;
          const [{ id, ...rest }] = sms;
          this.smsID = id;
          this.sms = rest;
          this.editSms = true;
        })
        .catch(() => {
          this.editSms = false;
        });
    },
    getController_id() {
      if (store.state.client) {
        return store.state.client.controller_id;
      } else {
        return "";
      }
    },
    getClient_id() {
      if (store.state.client) {
        return store.state.client.id;
      } else {
        return "";
      }
    },
    getClientName() {
      if (store.state.group_client_await) {
        return store.state.group_selected.text;
      } else {
        if (store.state.client) {
          return store.state.client.name;
        } else {
          return "";
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getID"]),
    textSms() {
      return ` Para utilizar o nome do cliente que receberá o SMS, utilize o texto
          <strong>{{nome}}</strong>. Por exemplo &quot;Obrigado por sua visita,  <strong>{{nome}}</strong>!&quot; será
          enviado como &quot;Obrigado por sua visita,  <strong>Mário</strong>!&quot;`;
    }
  },
  watch: {
    getID() {
      this.sms = {
        campaignID: 0,
        clientID: "",
        name: "",
        message: "",
        isEnabled: false,
        category: "transactional"
      };
      this.getClientSms();
    },
    "sms.message": function(newV) {
      this.smsLength = newV.length;
      if (-1 != newV.indexOf("'{{nome}}'")) {
        this.smsLength = this.smsLength + 2;
        this.maxLength = 158;
      } else {
        this.maxLength = 160;
      }
    }
  }
};
</script>
<style lang="scss">
.pag {
  padding: 50px;
}

.block {
  font-size: 25px;
  font-family: sans-serif;
  text-align: left;
}
#message {
  margin-bottom: 0px;
  width: 100%;
}
#containerMessage {
  text-align: start;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}
#containerMessage p {
  font-size: 15px;
  text-align: end;
  align-self: flex-end;
}
#subPag {
  font-size: 18px;
  font-family: sans-serif;
}

#bottonModal {
  text-align: left;
  display: flex;
  flex-direction: space-between;
}

#textExplication {
  font-family: sans-serif;
  font-size: 20px;
  text-align: left;
}

#textVariable {
  font-family: sans-serif;
  font-size: 20px;
  text-align: left;
}
.buttonContainer {
  margin-top: 5px;
  width: 100%;
}
.saveContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 250px;
  font-size: 1rem;
}
.sizeInputMedium {
  color: #eead2d;
}
.sizeInputHigh {
  color: #ff6961;
}
</style>



// WEBPACK FOOTER //
// src/components/Sms.vue